// extracted by mini-css-extract-plugin
export default {"button":"SaveButton_button__kRJgh","icon":"SaveButton_icon__WLOHR"};